import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import * as routes from '../../constants/routes';

class DynamicLink extends Component {
    render() {
        const { children, data = {}, className = '', onClick = () => {} } = this.props;

        let params = '';
        let component = (
            <span className={className}>
                Missing link data: {children}
            </span>
        );

        if (data.type) {
            if (data.type === 'internal') {
                if (Object.keys(data.parameters).length > 0) {
                    params = '/' + data.parameters.id;
                }

                component = (
                    <NavLink to={routes[data.route] + params} className={className} onClick={onClick}>
                        {children}
                    </NavLink>
                );
            } else if (data.type === 'contentPage') {
                component = (
                    <NavLink to={data.route} className={className} onClick={onClick}>
                        {children}
                    </NavLink>
                );
            } else {
                component = (
                    <a href={data.route} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>
                        {children}
                    </a>
                );
            }
        }

        return (
            <Fragment>
                {component}
            </Fragment>
        )
    }
}

// Connect to redux store
const mapStateToProps = (store) => {
    return {
        contentRoutes: store.config.contentRoutes,
    };
};

export default connect(mapStateToProps, null, null, { pure: false })(DynamicLink);
